/* ============================================================
   SENTINEL EF COLLECTION — sentinel-ef-collection.js
   Loaded once by sentinel-ef-collection-hero.liquid. Owns:
     - smooth-scroll for [data-efcol-scroll] (anchors AND buttons)
     - scroll-reveal for .efcol-section
     - the client-side filter engine (filter bar + post-type picker)
     - the "Composez votre système" interactive builder + cart-drawer ATC
   Body-class guarded so it only runs on collection.sentinel-electric.
   ============================================================ */

(function () {
  'use strict';

  /* The collection template body class is, exactly,
     "template-collection template-collection-sentinel-electric".
     classList.contains is an exact-token match — guard on our own token so
     this never runs on the welded collection or the PDP. */
  if (!document.body.classList.contains('template-collection-sentinel-electric')) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function hasToken(str, value) {
    if (!str) return false;
    return (' ' + str + ' ').indexOf(' ' + value + ' ') !== -1;
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' $';
  }

  /* ---------- Smooth scroll ---------- */
  function initScroll() {
    document.querySelectorAll('[data-efcol-scroll]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var sel = el.getAttribute('data-efcol-scroll') || el.getAttribute('href') || '';
        if (sel.charAt(0) !== '#') return;
        var target = document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var sections = document.querySelectorAll('.efcol-section');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window) ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      return; /* leave sections visible (no --will-reveal added) */
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('efcol-section--revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });
    sections.forEach(function (s) {
      s.classList.add('efcol-section--will-reveal');
      io.observe(s);
    });
  }

  /* ---------- Filter engine ---------- */
  function initFilters() {
    var grid = document.querySelector('[data-efcol-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-efcol-card]'));
    var countEl = grid.querySelector('[data-efcol-count]');
    var emptyEl = grid.querySelector('[data-efcol-empty]');
    var resetBtns = Array.prototype.slice.call(document.querySelectorAll('[data-efcol-reset]'));
    var chips = Array.prototype.slice.call(grid.querySelectorAll('[data-efcol-filter]'));
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-efcol-mount]'));

    var state = { category: '', mount: '', conductor: '' };

    function syncGroup(filter, value) {
      chips.forEach(function (chip) {
        if (chip.getAttribute('data-efcol-filter') !== filter) return;
        var on = chip.getAttribute('data-efcol-value') === value;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function anyActive() {
      return state.category !== '' || state.mount !== '' || state.conductor !== '';
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok =
          (!state.category || card.getAttribute('data-category') === state.category) &&
          (!state.mount || hasToken(card.getAttribute('data-mount'), state.mount)) &&
          (!state.conductor || hasToken(card.getAttribute('data-conductor'), state.conductor));
        card.hidden = !ok;
        if (ok) visible++;
      });
      if (countEl) countEl.textContent = visible + (visible === 1 ? ' produit' : ' produits');
      if (emptyEl) emptyEl.hidden = visible !== 0;
      resetBtns.forEach(function (b) { b.hidden = !anyActive(); });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-efcol-filter');
        state[filter] = chip.getAttribute('data-efcol-value');
        syncGroup(filter, state[filter]);
        apply();
      });
    });

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        state.mount = tile.getAttribute('data-efcol-mount') || '';
        syncGroup('mount', state.mount);
        apply();
        /* visual active state on the picker tiles */
        tiles.forEach(function (t) { t.classList.toggle('is-active', t === tile); });
      });
    });

    resetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = ''; state.mount = ''; state.conductor = '';
        syncGroup('category', ''); syncGroup('mount', ''); syncGroup('conductor', '');
        tiles.forEach(function (t) { t.classList.remove('is-active'); });
        apply();
      });
    });

    apply();
  }

  /* ---------- Cart drawer (FGE pattern) ---------- */
  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      var cartLink = document.getElementById('cart-icon-bubble');
      if (cartLink) cartLink.click();
      return Promise.resolve();
    }
    if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) { cartDrawer.renderContents({ sections: sections }); })
      .catch(function () {
        var cartLink = document.getElementById('cart-icon-bubble');
        if (cartLink) cartLink.click();
      });
  }

  /* ---------- Quick-add from grid cards ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-efcol-add]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-efcol-variant');
      if (!id) return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Ajout...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: 'id=' + encodeURIComponent(id) + '&quantity=1'
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw (err && err.description) || 'Ajout impossible.'; });
          return res.json();
        })
        .then(function () { return openCartDrawer(); })
        .then(function () { btn.innerHTML = orig; btn.disabled = false; })
        .catch(function (msg) {
          btn.innerHTML = orig; btn.disabled = false;
          alert(typeof msg === 'string' ? msg : 'Ajout impossible. Réessayez.');
        });
    });
  }

  /* ---------- System builder ---------- */
  function initSystemBuilder() {
    var root = document.querySelector('[data-efcol-system]');
    if (!root) return;
    var dataEl = root.querySelector('[data-efcol-system-data]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(products) || !products.length) return;

    var elConductors = root.querySelector('[data-efcol-sys-conductors]');
    var elInsulators = root.querySelector('[data-efcol-sys-insulators]');
    var elStrainers = root.querySelector('[data-efcol-sys-strainers]');
    var elHandles = root.querySelector('[data-efcol-sys-handles]');
    var elList = root.querySelector('[data-efcol-sys-list]');
    var elPlaceholder = root.querySelector('[data-efcol-sys-placeholder]');
    var elTotal = root.querySelector('[data-efcol-sys-total]');
    var elTotalVal = root.querySelector('[data-efcol-sys-total-value]');
    var elAddAll = root.querySelector('[data-efcol-sys-addall]');
    var mountOpts = Array.prototype.slice.call(root.querySelectorAll('[data-efcol-sysmount]'));

    var state = { mount: '', conductorClass: '', conductorId: null, items: {} };

    function inCat(p, cat) { return p.category === cat; }
    function condOK(p) {
      return !state.conductorClass ||
        (Array.isArray(p.conductor) && p.conductor.indexOf(state.conductorClass) !== -1);
    }
    function mountOK(p) {
      if (!Array.isArray(p.mount)) return false;
      return p.mount.indexOf(state.mount) !== -1 || p.mount.indexOf('universel') !== -1;
    }

    function pickRow(p, opts) {
      var selected = !!state.items[p.id];
      var row = document.createElement('div');
      row.className = 'efcol-pick' + (selected ? ' is-selected' : '');
      var img = p.image
        ? '<img class="efcol-pick__img" src="' + p.image + '" alt="" loading="lazy" width="48" height="48">'
        : '<span class="efcol-pick__img"></span>';
      row.innerHTML =
        img +
        '<span class="efcol-pick__main">' +
          '<span class="efcol-pick__title">' + p.title + '</span>' +
          '<span class="efcol-pick__price">' + (p.priceLabel || '') + '</span>' +
        '</span>' +
        '<button type="button" class="efcol-pick__btn">' +
          (selected ? opts.onLabel : opts.offLabel) + '</button>';
      row.querySelector('.efcol-pick__btn').addEventListener('click', function () {
        opts.toggle(p);
      });
      return row;
    }

    function fillList(container, list, opts) {
      if (!container) return;
      container.innerHTML = '';
      if (opts.hint) {
        var h = document.createElement('p');
        h.className = 'efcol-system__hint';
        h.textContent = opts.hint;
        container.appendChild(h);
        return;
      }
      if (!list.length) {
        var e = document.createElement('p');
        e.className = 'efcol-system__hint';
        e.textContent = opts.empty || 'Aucune pièce compatible pour le moment.';
        container.appendChild(e);
        return;
      }
      list.forEach(function (p) { container.appendChild(pickRow(p, opts)); });
    }

    function lockStep(name, locked) {
      var step = root.querySelector('[data-efcol-step="' + name + '"]');
      if (step) step.classList.toggle('is-locked', locked);
    }

    function toggleItem(p) {
      if (state.items[p.id]) delete state.items[p.id];
      else state.items[p.id] = { id: p.id, title: p.title, price: p.price, priceLabel: p.priceLabel, qty: 1 };
      renderAll();
    }

    function selectConductor(p) {
      if (state.conductorId === p.id) {
        /* deselect */
        delete state.items[p.id];
        state.conductorId = null;
        state.conductorClass = '';
      } else {
        if (state.conductorId && state.items[state.conductorId]) delete state.items[state.conductorId];
        state.conductorId = p.id;
        state.conductorClass = (Array.isArray(p.conductor) && p.conductor[0]) || '';
        state.items[p.id] = { id: p.id, title: p.title, price: p.price, priceLabel: p.priceLabel, qty: 1 };
      }
      renderAll();
    }

    function renderConductors() {
      var list = products.filter(function (p) { return inCat(p, 'fil-ruban'); });
      fillList(elConductors, list, {
        onLabel: 'Choisi ✓', offLabel: 'Choisir',
        empty: 'Aucun conducteur dans la gamme.',
        toggle: selectConductor
      });
      /* reflect selection */
      Array.prototype.forEach.call(elConductors.querySelectorAll('.efcol-pick'), function (row, i) {
        if (list[i] && state.conductorId === list[i].id) row.classList.add('is-selected');
      });
    }

    function renderInsulators() {
      if (!state.mount) {
        fillList(elInsulators, [], { hint: 'Choisissez d’abord votre type de poteau (étape 1).' });
        lockStep('insulators', true);
        return;
      }
      lockStep('insulators', false);
      var list = products.filter(function (p) { return inCat(p, 'isolateur') && mountOK(p) && condOK(p); });
      fillList(elInsulators, list, {
        onLabel: 'Ajouté ✓', offLabel: 'Ajouter',
        empty: 'Aucun isolateur compatible avec cette combinaison.',
        toggle: toggleItem
      });
    }

    function renderFinish() {
      var hasCond = !!state.conductorClass;
      lockStep('finish', !hasCond);
      var strainers = products.filter(function (p) { return inCat(p, 'tendeur-connecteur') && condOK(p); });
      var handles = products.filter(function (p) { return inCat(p, 'poignee') && condOK(p); });
      var hint = hasCond ? null : 'Choisissez un conducteur (étape 2) pour voir les pièces compatibles.';
      fillList(elStrainers, strainers, { onLabel: 'Ajouté ✓', offLabel: 'Ajouter', toggle: toggleItem, hint: hint });
      fillList(elHandles, handles, { onLabel: 'Ajouté ✓', offLabel: 'Ajouter', toggle: toggleItem, hint: hint });
    }

    function renderSummary() {
      var ids = Object.keys(state.items);
      elList.innerHTML = '';
      var total = 0;
      ids.forEach(function (id) {
        var it = state.items[id];
        total += (it.price || 0) * it.qty;
        var li = document.createElement('li');
        li.className = 'efcol-sysitem';
        li.innerHTML =
          '<span class="efcol-sysitem__main">' +
            '<span class="efcol-sysitem__title">' + it.title + '</span>' +
            '<span class="efcol-sysitem__meta">' + (it.priceLabel || money(it.price)) + '</span>' +
          '</span>' +
          '<button type="button" class="efcol-sysitem__remove" aria-label="Retirer">&times;</button>';
        li.querySelector('.efcol-sysitem__remove').addEventListener('click', function () {
          delete state.items[id];
          if (state.conductorId === id) { state.conductorId = null; state.conductorClass = ''; }
          renderAll();
        });
        elList.appendChild(li);
      });
      var has = ids.length > 0;
      if (elPlaceholder) elPlaceholder.hidden = has;
      if (elTotal) elTotal.hidden = !has;
      if (elTotalVal) elTotalVal.textContent = money(total);
      if (elAddAll) elAddAll.disabled = !has;
    }

    function renderAll() {
      renderConductors();
      renderInsulators();
      renderFinish();
      renderSummary();
    }

    mountOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        state.mount = opt.getAttribute('data-efcol-sysmount') || '';
        mountOpts.forEach(function (o) { o.classList.toggle('is-active', o === opt); });
        renderInsulators();
      });
    });

    if (elAddAll) {
      elAddAll.addEventListener('click', function () {
        var items = Object.keys(state.items).map(function (id) {
          return { id: parseInt(id, 10), quantity: state.items[id].qty };
        });
        if (!items.length) return;
        var original = elAddAll.textContent;
        elAddAll.disabled = true;
        elAddAll.textContent = 'Ajout en cours...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw (err && err.description) || 'Ajout impossible.'; });
            return res.json();
          })
          .then(function () { return openCartDrawer(); })
          .then(function () {
            elAddAll.textContent = original;
            elAddAll.disabled = false;
          })
          .catch(function (msg) {
            elAddAll.textContent = original;
            elAddAll.disabled = false;
            alert(typeof msg === 'string' ? msg : 'Ajout impossible. Réessayez.');
          });
      });
    }

    renderAll();
  }

  ready(function () {
    initScroll();
    initReveal();
    initFilters();
    initQuickAdd();
    initSystemBuilder();
  });
})();
